import React from 'react'
import { Stack, Typography } from '@mui/material'

export const DrivesSectionHeader = ({ title, icon: Icon, description }) => (
  <Stack spacing={1} sx={{ mb: 2 }}>
    <Typography variant='h5' fontWeight={700}>
      {title}
    </Typography>
    <Stack direction='row' spacing={1} alignItems='center'>
      <Icon sx={{ fontSize: 20, color: 'text.primary' }} />
      <Typography variant='body2' color='text.secondary'>
        {description}
      </Typography>
    </Stack>
  </Stack>
)
